// extracted by mini-css-extract-plugin
module.exports = {"container":"_vgQh9Rs","noData":"_mWElRic"};